
<template>
  <div>
    <div class="row">
      <div v-if="ajuste" class="col-12 def-title">
        Ajuste de Estoque
      </div>
      <div v-if="transferencia" class="col-12 def-title">
        Transferência de Depósito
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-12 lbl-title">
        PRODUTO SELECIONADO
      </div>
    </div>
    <div class="row pl-5">
      <div class="col-md-12 col-12">
        <v-label class="w-100" :metadata-field="metadata.mest.coditem"></v-label>
        <div class="">
          <input-item ref="item" v-model="coditem" @onselect="handleSelecionaItem"></input-item>
        </div>
      </div>
    </div>
    <div class="row pl-5" v-if="item.isgrade && item.isgrade === 'S'">
      <div class="col-md-12 col-12">
        <v-label class="w-100" :metadata-field="metadata.mest.coditemgrade"></v-label>
        <div class="">
          <form-field v-model="coditemgrade" type="select2" col="4"
            :select2="{ entity: '/grades/item/' + item.coditem, minlength: 0 }"></form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 lbl-title">
        LOCAL / LOTE SELECIONADO
      </div>
    </div>
    <div class="row pl-5">
      <div class="col-md-12 col-12">
        <label class="lbl-edit w-100">Depósito</label>
        <span class="data-list">{{ estoque.descricao }}</span>
      </div>
      <div class="col-md-12 col-12" v-if="estoque.linha && estoque.linha !== ''">
        <label class="lbl-edit w-100">Linha(Grade)</label>
        <span class="data-list">{{ estoque.linha }}</span>
      </div>
      <div class="col-md-12 col-12" v-if="estoque.coluna && estoque.coluna !== ''">
        <label class="lbl-edit w-100">Coluna(Grade)</label>
        <span class="data-list">{{ estoque.coluna }}</span>
      </div>

      <div class="col-md-12 col-12" v-if="dadosEstoqueItem.controlalocal">
        <label class="lbl-edit w-100">Local</label>
        <span class="data-list">{{ estoque.local }}</span>
      </div>
      <div class="col-md-12 col-12" v-if="dadosEstoqueItem.controlalote">
        <label class="lbl-edit w-100">Identificação do Lote</label>
        <span class="data-list">{{ estoque.lote }}</span>
      </div>
      <div class="col-md-12 col-12" v-if="dadosEstoqueItem.controlalote">
        <label class="lbl-edit w-100">Sublote</label>
        <span class="data-list">{{ estoque.sublote }}</span>
      </div>
      <div class="col-md-12 col-12">
        <label class="lbl-edit w-100">Quantidade</label>
        <span class="data-list">{{ estoque.qt | formatValue(4) }}</span>
      </div>
    </div>

    <div class="row" v-if="ajuste">
      <div class="col-12 lbl-title">
        INFORME O TIPO DE AJUSTE E A QUANTIDADE
      </div>
    </div>
    <div class="row pl-5" v-if="ajuste">
      <form-field v-model="tipo" type="select" col="3" :metadata="metadata.mest.tpmest"></form-field>
      <div class="w-100"></div>
      <form-field v-model="qt" type="value" col="3" label="Quantidade do ajuste" :precision="2" name="qt"
        :v-errors="errors" v-validate="metadata.mest.qt.validator"></form-field>
      <div class="w-100"></div>

      <form-field v-model="motivo" type="text" col="6" label="Motivo do ajuste" name="motivo" :v-errors="errors"
        v-validate="{ required: true, max: 50 }"></form-field>
      <div class="w-100"></div>
      <form-field v-if="!codqest && coditem" v-model="estoque.coddeposito" type="select2" col="4"
        :metadata="metadata.mest.coddeposito" name="coddeposito" :v-errors="errors"
        v-validate="metadata.mest.coddeposito.validator"></form-field>
      <div class="w-100"></div>
      <form-field v-if="!codqest && coditem && item && item.controlalocal == 'S'" v-model="estoque.local" type="text"
        col="6" :metadata="metadata.mest.local" name="local" :v-errors="errors"
        v-validate="metadata.mest.local.validator"></form-field>
      <div class="w-100"></div>
      <form-field v-if="!codqest && coditem && item && item.controlalote" v-model="estoque.lote" type="text" col="6"
        :metadata="metadata.mest.lote" name="lote" :v-errors="errors" v-validate="metadata.mest.lote.validator">
      </form-field>
      <div class="w-100"></div>
      <form-field v-if="!codqest && coditem && item && item.controlalote" v-model="estoque.sublote" type="text" col="6"
        :metadata="metadata.mest.sublote" name="sublote" :v-errors="errors"
        v-validate="metadata.mest.sublote.validator"></form-field>
    </div>
    <div class="row" v-if="ajuste && errmessages.length == 0 && qt > 0">
      <div class="col-md-12 col-12">
        <alert type="success" :text="novoSaldo"></alert>
      </div>
    </div>


    <div class="row" v-if="transferencia">
      <div class="col-12 lbl-title">
        INFORME O DEPÓSITO OU LOCAL DE DESTINO E A QUANTIDADE
      </div>
    </div>
    <div class="row pl-5" v-if="transferencia">
      <form-field v-model="coddeposito" type="select2" col="4" :metadata="metadata.mest.coddeposito" name="coddeposito"
        :v-errors="errors" v-validate="metadata.mest.coddeposito.validator"></form-field>
      <div class="w-100"></div>
      <form-field v-if="item && item.controlalocal == 'S'" v-model="local" type="text" col="6"
        :metadata="metadata.mest.local" name="local" :v-errors="errors" v-validate="metadata.mest.local.validator">
      </form-field>
      <form-field v-model="qt" type="value" col="2" label="Quantidade a transferir" :precision="2" name="qt"
        :v-errors="errors" v-validate="metadata.mest.qt.validator"></form-field>
      <div class="w-100"></div>
    </div>


    <!-- MENSAGENS DE VALIDACAO -->
    <div class="row mt-3" v-if="errmessages.length != 0">
      <div class="col-md-12 col-12">
        <validation title="Erros de Validação" :messages="errmessages"></validation>
      </div>
    </div>

    <hr>

    <div class="row mt-3 mb-2">
      <div class="col-md-12 col-12">
        <v-button label="Salvar" :nb-btdef="true" class="" @click="handleSave"></v-button>
        <v-button label="Cancelar" class="" @click="closeForm"></v-button>
      </div>
    </div>

  </div>
</template>

<script>

import { SysVars } from '../main'
import { formatValue } from '../shared/utils'
import { apiORDS, apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
  props: {
    params: Object
  },

  data() {
    return {
      crudText: '',
      mest: { ...this.$store.getters.getEntities.mest },
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela

      coditem: null,
      coditemgrade: null,
      codqest: null,
      coddeposito: null,
      tipo: null,
      motivo: null,
      qt: null,
      estoque: {
        coddeposito: null,
        local: null,
        lote: null,
        sublote: null,
      },
      item: null,
      dadosEstoqueItem: null, //item selecionado
    }
  },

  computed: {
    editing: function () {
      return this.crud == SysVars.crudU
    },

    transferencia: function () {
      return this.params.transferencia
    },

    ajuste: function () {
      return this.params.ajuste
    },

    novoSaldo: function () {
      let saldo = Number(this.estoque.qt)
      console.log(saldo)
      if (isNaN(saldo)) {
        saldo = 0;
      }

      if (this.tipo == 'S') {
        saldo -= Number(this.qt)
      }
      else {
        saldo += Number(this.qt)
      }

      if (this.estoque.lote)
        return 'O novo saldo para este lote será de: ' + formatValue(saldo, 4)
      else
        return 'O novo saldo será de: ' + formatValue(saldo, 4)
    },

    itemList: function () {
      return this.$store.getters.getItemSalesList
    },


  },

  methods: {
    handleSelecionaItem(item) {
      this.item = item
      if (!item) return
      this.coditem = item.coditem
      this.loadDadosItem()
    },

    handleSelecionaLote() {
      console.log('selecionalote')
      this.estoque = null
    },

    closeForm() {
      this.$emit('closeform')
    },

    itemgradeValidate() {
      let result = false

      this.errmessages = []

      if ((this.item.isgrade) && (this.item.isgrade === 'S') && (!this.coditemgrade)) {
        this.errmessages.push("Item grade inválido!")
        result = true
      }
      // console.log('itemgtin validate ' + result)
      return result

    },


    handleSave() {
      //BOTAO SALVAR
      this.$validator.validateAll().then(isValid => {

        let lErro = false
        if (this.itemgradeValidate()) {
          lErro = true
        }
        if (!isValid || lErro) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          this.apiPost()
        }
      })
    },

    handleDelete() {
      //BOTAO Excluir
      this.apiDelete()
    },

    async loadDadosItem() {


      let params = { filter: null, coditem: this.coditem, codtabpre: null };

      await this.$store.dispatch('loadItemSales', params)
      this.selectedIndex = 0
      if (this.coditem && this.itemList.length > 0) {
        this.item = this.itemList[0]
      }


      // CARREGA AS INFORMAÇÕES DE ESTOQUE DO PRODUTO

      let url = "consulta/estoque/estoqueproduto";

      this.filtro = {
        coditem: this.coditem,
      }

      const data = await apiORDSpost(this.$store, url, this.filtro, "post")
      if (data) {
        this.dadosEstoqueItem = data
      } else {

      }

      let self = this
      let estoque = null
      estoque = this.dadosEstoqueItem.estoque.detalhes.filter(function (obj) {
        return obj.codqest == self.codqest
      })

      if (estoque.length > 0) {
        this.estoque = estoque[0]
        this.coditemgrade = this.estoque.coditemgrade
      }

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })

    },

    async loadData() {
      let self = this
      // this.mest = null

      apiORDS(this.$store.getters.urlOrds + 'estoque/movimento/' + this.index, null, true).then((result) => {
        self.mest = result.items[0]
      })

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    // async apiDelete () {
    //     //efetua a exclusao
    //     var modulo = 'estoque/movimento/' + this.estado.uf

    //     const data = await apiORDSdelete(this.$store, modulo)
    //     this.$erpToastDeleted()
    //     this.closeForm()
    // },

    async apiPost() {
      var modulo = 'estoque/movimento/'
      var sendData = {}

      sendData = {
        movimento: {
          estoque: this.estoque,
          coditem: this.coditem,
          coditemgrade: this.coditemgrade,
          tipo: this.tipo,
          motivo: this.motivo,
          qt: this.qt
        }
      }

      if (this.transferencia) {
        sendData.movimento.destino = { coddeposito: this.coddeposito, local: this.local }
        sendData.movimento.transferencia = this.transferencia
      } else {
        sendData.movimento.ajuste = this.ajuste
      }

      let metodo = 'post'

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (data.errmessages) {
        this.errmessages = data.errmessages
        this.$erpToastError('O movimento não foi concluído.')
      } else {
        this.$erpToastInserted()
        this.errmessages = []
        this.closeForm()
      }
    },

  },

  components: {

  },

  beforeCreate() {

  },

  created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })

    if (this.params && this.params.coditem)
      this.coditem = this.params.coditem
    if (this.params && this.params.codqest)
      this.codqest = this.params.codqest

    this.loadDadosItem()

    // this.crudText = this.$crudText(this.crud)

    // if (this.$route.params.item)
    //   this.coditem = this.$route.params.item

  }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms-estoque/estoque-ajuste-transferencia-form.vue